import {
  FETCH_CLIENTS_SUCCESSFUL,
  FETCH_CLIENTS_FAILED,
  REGISTER_CLIENT_SUCCESSFUL,
  REGISTER_CLIENT_FAILED,
  UPDATE_CLIENT_SUCCESSFUL,
  UPDATE_CLIENT_FAILED,
  DELETE_CLIENT_SUCCESSFUL,
  DELETE_CLIENT_FAILED,
} from "./actionTypes";

const initialState = {
  clients: [],
  loading: false,
  registrationError: null,
  error: null
};

const clientReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLIENTS_SUCCESSFUL:
      return { ...state, clients: action.payload, loading: false };
    case FETCH_CLIENTS_FAILED:
      return { ...state, error: action.payload, loading: false };
    case REGISTER_CLIENT_SUCCESSFUL:
      return {
        ...state,
        clients: [...state.clients, action.payload],
        loading: false,
      };
    case REGISTER_CLIENT_FAILED:
      return { ...state, registrationError: action.payload, loading: false };
    case UPDATE_CLIENT_SUCCESSFUL:
      return { ...state, loading: false };
    case UPDATE_CLIENT_FAILED:
      return { ...state, registrationError: action.payload, loading: false };
    case DELETE_CLIENT_SUCCESSFUL:
      return {
        ...state,
        clients: state.clients.filter(
          (client) => client.clientId !== action.payload
        ),
      };
    case DELETE_CLIENT_FAILED:
      return { ...state, registrationError: action.payload, loading: false };
    default:
      return state;
  }
};

export default clientReducer;
